import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { IconButton } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Radio, RadioGroup,TextField ,FormLabel,FormControlLabel} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import {  FormGroup, Typography,   ClickAwayListener,ListItemText 
 } from "@mui/material";
  import {Autocomplete,} from "@mui/material";
  import DeleteIcon from "@mui/icons-material/Delete";
 
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  StepConnector,
  stepConnectorClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Checkbox, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { keyframes } from "@mui/system";
import Pagination from "@mui/material/Pagination";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { Country, State, City } from "country-state-city";
import { formatDateDDMMYYYY } from "utils/dateFormatter";
import "../styles/form-labels.css";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";

function CreatePatientProfile() {
   const date = new Date();
  let day = date.getDate().toString().padStart(2, "0");
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let year = date.getFullYear();
  let currentDate = `${year}-${month}-${day}`;
   const getCurrentDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
     const [formErrors, setFormErrors] = useState({});

  const [selectedDealerId, setSelectedDealerId] = useState(null);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
const [openDelearModal, setOpenDelearModal] = useState(false);
const [selectedDelearId, setSelectedDelearId] = useState(null);
const [selectedDelearName, setSelectedDelearName] = useState(null);
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState("");
  const [devicename, setDevicename] = useState("");
  const [device_id, setDevice_id] = useState("");
  const [devices, setDevices] = useState([]);
  const [showCustomFields, setShowCustomFields] = useState(false);
  const [customerTypes, setCustomerTypes] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldData, setCustomFieldData] = useState({});
  const [showDocuments, setShowDocuments] = useState(false);
const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [specializationList, setSpecializationList] = useState([]);
  const [counsilList, setCounsilList] = useState([]);
    const [doctorList, setDoctorList] = useState([]);
  const [doctorNameList, setDoctorNameList] = useState([]);
const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"

  const [activeStep, setActiveStep] = useState(0);

  const [customerDetails, setCustomerDetails  ] = useState({
    username: "",
    role: "",
    patRegentity: {
      id: "",
      firstname: "",
      lastname: "",
      imageMeta:"",
      image:"",
      phone: "",
phoneCountryCode: "+91",
emergencyCountryCode: "+91", 
    age:"",
     martialStatus:"",
     gender:"",
     dob:"",
     address:"",
     address1:"",
     district:"",
    state:"",
    country:"",
    pin:"",
    emergencyPhoneNumber:"",
    primarydoctorid:"",
    },
   
    document:[
     {
      documentname: "",
      documenttype: "",
      dateofupload:  getCurrentDate(),
      imageMeta: "",
      image: "",
    },
    ],
  });
  const countryCodes = [
  { code: "+91", name: "India" },
  { code: "+1", name: "USA" },
  { code: "+44", name: "UK" },
  { code: "+61", name: "Australia" },
  { code: "+971", name: "UAE" },
];
const countryPhoneRules = {
  "+91": 10, // India
  "+1": 10,  // USA / Canada
  "+44": 10, // UK
  "+61": 9,  // Australia
  "+971": 9, // UAE
};
const countryPhonePatterns = {
  "+91": /^[6-9]\d{9}$/, // India: must start with 6–9 and be 10 digits
  "+1": /^[2-9]\d{9}$/,  // USA: first digit cannot be 0 or 1
  "+44": /^\d{10}$/,     // UK: 10 digits
  "+61": /^\d{9}$/,      // Australia: 9 digits
  "+971": /^\d{9}$/,     // UAE: 9 digits
};
 useEffect(() => {
    setCountries(Country.getAllCountries()); // all countries
  }, []);

  // when country changes → update states
  const handleCountryChange = (countryCode) => {
    setCustomerDetails({
      ...customerDetails,
      patRegentity: { ...customerDetails.patRegentity, country: countryCode, state: "", district: "" },
    });
    setStates(State.getStatesOfCountry(countryCode));
    setDistricts([]); // reset districts
  };

  // when state changes → update districts
  const handleStateChange = (stateCode) => {
    setCustomerDetails({
      ...customerDetails,
      patRegentity: { ...customerDetails.patRegentity, state: stateCode, district: "" },
    });
    setDistricts(City.getCitiesOfState(customerDetails.patRegentity.country, stateCode));
  };

   const fetchSpecializations = async () => {
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get("/api/specializationList", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setSpecializationList(decryptedData || []);
        console.log("Specialization List:", decryptedData.content);
      }
    } catch (error) {
      console.error("Error fetching specialists:", error);
    } finally {
      setLoading(false);
    }
  };

 const fetchCounsilNames = async () => {
    try {
      setLoading(true);
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get("/api/counsilNames", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setCounsilList(decryptedData|| []);
      }
    } catch (error) {
      console.error("Error fetching counsil names:", error);
    } finally {
      setLoading(false);
    }
  };

   const fetchDoctorType = async () => {
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get("/api/doctortype", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setDoctorList(decryptedData || []);
        console.log("Specialization List:", decryptedData.content);
      }
    } catch (error) {
      console.error("Error fetching specialists:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSpecializations();
    fetchCounsilNames();
    fetchDoctorType();
  }, []);
const fetchDoctorName = async (doctorType) => {
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/doctorregistration/doctorType/${doctorType}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setDoctorNameList(decryptedData || []);
        console.log("Specialization List:", decryptedData.content);
      }
    } catch (error) {
      console.error("Error fetching specialists:", error);
    } finally {
      setLoading(false);
    }
  };
 

  useEffect(() => {
    fetchDoctorType();
  }, []);

  useEffect(() => {
    if (customerDetails.patRegentity?.doctorType) {
      fetchDoctorName(customerDetails.patRegentity.doctorType);
      setCustomerDetails((prev) => ({
        ...prev,
        patRegentity: { ...prev.patRegentity, doctorName: "" },
      }));
    }
  }, [customerDetails.patRegentity?.doctorType]);

 const handleAddDocument = () => {
  setCustomerDetails((prev) => ({
    ...prev,
    document: [
      ...prev.document,
      {
        documentname: "",
        documenttype: "",
        dateofupload:  getCurrentDate(),
        imageMeta: "",
        image: "",
      },
    ],
  }));
};



  const [customersList, setCustomersList] = useState([]);  
  const navigate = useNavigate();

  const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
const validatePhoneNumber = (phone) => {
  const regex = /^[0-9]{10}$/; // exactly 10 digits
  return regex.test(phone.trim());
};
const validateDocuments = () => {
  let hasError = false;
  const updatedDocs = [...customerDetails.document];

  // Check duplicates
  const docNames = updatedDocs.map((d) => d.documentname);
  const duplicates = docNames.filter((item, index) => docNames.indexOf(item) !== index);
  if (duplicates.length > 0) {
    toast.error(`Duplicate document uploaded: ${duplicates[0]}`);
    hasError = true;
  }

  // Required documents
  const requiredDocs = ["Aadhar Card"];
  const optionalEitherDocs = ["Pan Card", "Driving License"];

  // ✅ Check for required documents (like Aadhar)
  requiredDocs.forEach((docName) => {
    let doc = updatedDocs.find((d) => d.documentname === docName);
    let idx = updatedDocs.findIndex((d) => d.documentname === docName);

    if (!doc) {
      doc = { documentname: docName, documenttype: "", dateofupload:  "", image: "", errors: {} };
      updatedDocs.push(doc);
      idx = updatedDocs.length - 1;
    }

    const errors = {};
    if (!doc.image) errors.image = "File upload is required";

    if (Object.keys(errors).length > 0) {
      toast.error(`${docName} is required with File.`);
      hasError = true;
    }

    updatedDocs[idx].errors = errors;
  });

  // ✅ Check for at least one of Pan Card or Driving License
  const hasEither =
    updatedDocs.some((d) => d.documentname === "Pan Card" && d.image) ||
    updatedDocs.some((d) => d.documentname === "Driving License" && d.image);

  // if (!hasEither) {
  //   toast.error("Either Pan Card or Driving License must be uploaded.");
  //   hasError = true;xc
  // }

  setCustomerDetails({ ...customerDetails, document: updatedDocs });
  return !hasError;
};

const validateStep0 = () => {
  const errors = {};

   const phoneCode = customerDetails.patRegentity?.phoneCountryCode || "+91";
      const emergencyCode = customerDetails.patRegentity?.emergencyCountryCode || "+91";

  const phone = customerDetails.patRegentity?.phone?.trim() || "";
  const emergencyPhoneNumber = customerDetails.patRegentity?.emergencyPhoneNumber?.trim() || "";

  const { patRegentity, username } = customerDetails;
  const reg = customerDetails.patRegentity;
   const nameRegex = /^[A-Za-z\s]+$/;
  const usernameRegex = /^[a-zA-Z0-9_]+$/;
const countryPhonePatterns = {
    "+91": /^[6-9]\d{9}$/, // India
    "+1": /^[2-9]\d{9}$/,  // USA
    "+44": /^\d{10}$/,     // UK
    "+61": /^\d{9}$/       // Australia
  };

  const countryPhoneRules = {
    "+91": 10,
    "+1": 10,
    "+44": 10,
    "+61": 9
  };

  const expectedLength = countryPhoneRules[phoneCode] || 10;
  const pattern = countryPhonePatterns[phoneCode];
  if (!phone) {
    errors.phone = "Phone number is required";
  } else if (!/^\d+$/.test(phone)) {
    errors.phone = "Phone number must contain only digits";
  } else if (phone.length !== expectedLength) {
    errors.phone = `Invalid phone number length for ${phoneCode}. Expected ${expectedLength} digits.`;
  } else if (pattern && !pattern.test(phone)) {
    errors.phone = `Invalid phone number format for ${phoneCode}`;
  } else if (!pattern && (phone.length < 6 || phone.length > 15)) {
    errors.phone = `Invalid phone number format for ${phoneCode}`;
  }
const expectedLengthEmergency = countryPhoneRules[emergencyCode] || 10;
  const patternEmergency = countryPhonePatterns[emergencyCode];
   if (!emergencyPhoneNumber) {
    errors.emergencyPhoneNumber = " Emergency Phone number is required";
  } else if (!/^\d+$/.test(phone)) {
    errors.emergencyPhoneNumber = " Emergency Phone number must contain only digits";
  } else if (emergencyPhoneNumber.length !== expectedLengthEmergency) {
    errors.emergencyPhoneNumber = ` Emergency Invalid phone number length for ${emergencyCode}. Expected ${expectedLengthEmergency} digits.`;
  } else if (patternEmergency && !patternEmergency.test(emergencyPhoneNumber)) {
    errors.emergencyPhoneNumber = ` Emergency Invalid phone number format for ${emergencyCode}`;
  } else if (!patternEmergency && (emergencyPhoneNumber.length < 6 || emergencyPhoneNumber.length > 15)) {
    errors.emergencyPhoneNumber = ` Emergency Invalid phone number format for ${emergencyCode}`;
  }

  // ✅ Country code validation
  if (!reg.phoneCountryCode || reg.phoneCountryCode.trim() === "") {
    errors.phone = "Country code is required";
  }
  if (!reg.emergencyCountryCode || reg.emergencyCountryCode.trim() === "") {
    errors.phone = "Country code is required";
  }
 if (!reg || !reg.firstname || !reg.firstname.trim()) {
    errors.firstname = "First Name is required";
  } else if (!nameRegex.test(reg.firstname.trim())) {
    errors.firstname = "First Name should contain only alphabets (no numbers or special characters)";
  } else if (reg.firstname.trim().length < 2) {
    errors.firstname = "First Name must be at least 2 characters long";
  }

  // --- Last Name ---
  if (!reg || !reg.lastname || !reg.lastname.trim()) {
    errors.lastname = "Last Name is required";
  } else if (!nameRegex.test(reg.lastname.trim())) {
    errors.lastname = "Last Name should contain only alphabets (no numbers or special characters)";
  }

 
  if (!customerDetails.username.trim()) errors.username = "Email is required";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customerDetails.username))
    errors.username = "Invalid email format";
  // if (!reg.phone.trim()) errors.phone = "Phone number is required";
  // else if (!validatePhoneNumber(reg.phone))
  //   errors.phone = "Phone number must be 10 digits";
  if (!reg.phone.trim()) errors.emergencyPhoneNumber = "Emergency number is required";
  else if (!validatePhoneNumber(reg.emergencyPhoneNumber))
    errors.phone = "Emergency number must be 10 digits";
  if (!reg.gender) errors.gender = "Gender is required";
  if (!reg.martialStatus) errors.martialStatus = "Marital Status is required";
if (!reg.dob) {
    errors.dob = "Date of Birth is required";
  } else {
    const dobDate = new Date(reg.dob);
    const today = new Date();
    if (dobDate > today) {
      errors.dob = "Date of Birth cannot be a future date";
    }
  }
  setFormErrors(errors);
  return Object.keys(errors).length === 0;
};

const validateStep1 = () => {
  const errors = {};
  const reg = customerDetails.patRegentity;

  if (!reg.address?.trim()) errors.address = "Address is required";
  if (!reg.country) errors.country = "Country is required";
  if (!reg.state) errors.state = "State is required";
  if (!reg.district) errors.district = "District is required";
  if (!reg.pin?.trim()) errors.pin = "Postal Code is required";

  setFormErrors(errors);
  return Object.keys(errors).length === 0;
};

const validateStep2 = () => {
  const errors = {};
  const reg = customerDetails.patRegentity;

  // if (!reg.nmcRegisteredNumber?.trim())
  //   errors.nmcRegisteredNumber = "NMC Registered Number is required";
  // if (!reg.hospitalAddress) errors.hospitalAddress = " Select Hospital Address ";
  // if (!reg.yearOfRegistration) errors.yearOfRegistration = "Year Of Registration is required";
  // if (!reg.doctorType) errors.doctorType = " Select Doctor Type ";
  //   if (!reg.verificationstatus) errors.verificationstatus= " Select Verification Status ";
  if (!reg.doctorType) errors.doctorType = "Doctor Type is required";
  if (!reg.primarydoctorid) errors.primarydoctorid = "Select Doctor Name";

  // if (customerDetails.specialization.length === 0)
  //   errors.specialization = "Select at least one specialization";

  setFormErrors(errors);
  return Object.keys(errors).length === 0;
};
  const handleSubmit = async (e) => {
    
    e.preventDefault();

   const docsValid = validateDocuments();
  if (!docsValid) {
    toast.error("Please upload the required documents before submitting.");
    return;
  }

    setLoading(true);
    try {
      
      const secretKey = await fetchSecretKey();
    
      
      const rawPayload = {
        username: customerDetails.username,
        role: "ROLE_USER",

        patRegentity: {

          firstname: customerDetails.patRegentity.firstname,
          lastname: customerDetails.patRegentity.lastname,
          imageMeta: customerDetails.patRegentity.imageMeta,
    image: customerDetails.patRegentity.image,
      phoneNumber: `${customerDetails.patRegentity.phone}`, // country first
      phonecountrycode:`${customerDetails.patRegentity.phoneCountryCode}`,
    age: customerDetails.patRegentity.age,
    martialStatus: customerDetails.patRegentity.martialStatus,
    gender: customerDetails.patRegentity.gender,
    dob: formatDateDDMMYYYY(customerDetails.patRegentity.dob),
    address: customerDetails.patRegentity.address,
    address1: customerDetails.patRegentity.address1,

    city: customerDetails.patRegentity.district,
    state: customerDetails.patRegentity.state,
    country: customerDetails.patRegentity.country,
    pin: customerDetails.patRegentity.pin,
   emergencyPhoneNumber: `${customerDetails.patRegentity.emergencyPhoneNumber}`, // country first
emergencycountrycode:`${customerDetails.patRegentity.emergencyCountryCode}`,
    primarydoctorid: customerDetails.patRegentity.primarydoctorid,
  
      doctorType: customerDetails.patRegentity.doctorType,

        },

        
document: customerDetails.document?.map((doc) => ({
    documentname: doc.documentname,
    documenttype: doc.documenttype,
   dateofupload: formatDateDDMMYYYY(doc.dateofupload ? doc.dateofupload : currentDate),
    imageMeta: doc.imageMeta,
    image: doc.image,
  })),

      };
  
      console.log("Raw Payload Before Encryption:", rawPayload); 
  
      const encryptedData = encryptBody(rawPayload, secretKey);
  
      console.log("Encrypted Payload:", encryptedData);
  
      const token = JSON.parse(localStorage.getItem("loginData")).token;
  
      // Register Dealer
      const response = await axios.post("/api/patient/register", encryptedData, {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        console.log("Decrypted Response:", decryptedResponse);

  
        if (!decryptedResponse) {
          throw new Error("Decryption failed, no data returned.");
        }
  
        if (decryptedResponse.success === "true") {
          
          toast.success(decryptedResponse.message || "Patient Profile Created successfully!");
          navigate(-1);
          setTimeout(() => {
            toast.info("Password has been sent to your email.");
          }, 1500);
          const dealerid = decryptedResponse?.dealerid; 
  
          // if (dealerid && deviceId) {
          //   await mapDealerToDevice(dealerid, deviceId, token);
          // }
  
          // Reset the form and update UI
          setCustomersList
((prevDealers) => [
            ...prevDealers,
            {
             firstname: customerDetails.patRegentity.firstname,
          lastname: customerDetails.patRegentity.lastname,
          imageMeta: customerDetails.patRegentity.imageMeta,
    image: customerDetails.patRegentity.image,
    phone: customerDetails.patRegentity.phone,
    locationid: customerDetails.patRegentity.locationid,
    age: customerDetails.patRegentity.age,
    martialStatus: customerDetails.patRegentity.martialStatus,
    gender: customerDetails.patRegentity.gender,
    dob: customerDetails.patRegentity.dob,
     emergencyPhoneNumber: customerDetails.patRegentity.emergencyPhoneNumber,
    primarydoctorid: customerDetails.patRegentity.primarydoctorid,
         
            },
          ]);
  
          setCustomerDetails
({
            username: "",
    role: "",
    patRegentity: {
      id: "",
      firstname: "",
      lastname: "",
      imageMeta:"",
      image:"",
      phone: "",
     locationid:"",
     age:"",
     martialStatus:"",
     gender:"",
     dob:"",
    address:"",
    address1:"",
        district:"",
    state:"",
    country:"",
    pin:"",
   
    },
   
    document:[
     {
      documentname: "",
      documenttype: "",
      dateofupload: getCurrentDate(),
      imageMeta: "",
      image: "",
    },
    ],
          });
  

        } else {
          toast.error(decryptedResponse?.message || "Failed to verify registration.");
        }
      }
    } catch (error) {
     console.error("Registration Error:", error);
   
     let errorMessage = "Registration failed"; // default message
   
     if (error.response) {
       const data = error.response.data;
   
       // ✅ If backend sends a structured JSON with a 'message' field
       if (typeof data === "object" && data.message) {
         errorMessage = data.message;
       } 
       // ✅ If backend sends a plain text message
       else if (typeof data === "string") {
         errorMessage = data;
       }
     } 
     // ✅ For network or other unexpected errors
     else if (error.message) {
       errorMessage = error.message;
     }
   
     toast.error(errorMessage);
   } finally {
     setLoading(false);
   }
     };
  
  
 

  

 
  const handleCancel = () => {
    setCustomerDetails
({
     username: "",
    role: "",
    patRegentity: {
      id: "",
      firstname: "",
      lastname: "",
      imageMeta:"",
      image:"",
      phone: "",
     locationid:"",
     age:"",
     martialStatus:"",
     gender:"",
     dob:"",
    address:"",
    address1:"",
        district:"",
    state:"",
    country:"",
    pin:"",
    NMCRegisteredNumber:"",
    yearOfRegistration:"",
    hospitalAddress:"",
verificationstatus:"",
    },
     specialization:[],
     counsil:[ ],
    document:[
     {
      documentname: "",
      documenttype: "",
      dateofupload: getCurrentDate(),
      imageMeta: "",
      image: "",
    },
    ],
    });
    navigate(-1); 
  };
   const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  const steps = ["Personal Info", "Address Info", "Professional Details", "Documents"];

   const handleNext = () => {
  let valid = false;

  if (activeStep === 0) {
    valid = validateStep0(); // Personal Info
  } else if (activeStep === 1) {
    valid = validateStep1(); // Address Info
  } else if (activeStep === 2) {
    valid = validateStep2(); // Professional Info
  } else if (activeStep === 3) {
    valid = validateDocuments(); // Documents
  }

  if (valid) {
    if (activeStep < steps.length - 1) setActiveStep((prev) => prev + 1);
    else handleSubmit(); // Final submit
  }
};
  const handleBack = () => {
    if (activeStep > 0) setActiveStep((prev) => prev - 1);
  };

 const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: "20px",
    left: 38,
    right: 170,
    marginLeft: "-100px",
    marginRight: "10px",
    position: "absolute",
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#1976d2",
    borderTopWidth: 2,
    borderRadius: 1,
  },
}));

const CustomStepper = styled(Stepper)(() => ({
  background: "transparent",
  padding: "1.5rem 0 1rem",
  boxShadow: "none",
  marginBottom: "32px",
  width: "100%",
}));

// Custom Step Icon
const StepIconContainer = styled("div")(({ ownerState }) => ({
  backgroundColor: ownerState.active
    ? "#516dd3" // Active = Blue
    : ownerState.completed
    ? "#2f995e" // Completed = Green
    : "#b0b5b7", // Inactive = Grey
  color: "#fff",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "8px 12px",
  borderRadius: "50px", // pill shape
  fontSize: "12px",
  fontWeight: "bold",
  textAlign: "center",
  minWidth: "120px", // ensures pill box width
  boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
}));

function CustomStepIcon(props) {
  const { active, completed, className, icon } = props;
  const ownerState = { active, completed };

  // Map step numbers to your custom labels
  const stepLabels = [
    "Personal Info",
    "Address Info",
    "Mapping Info",
    "Documents Upload",
  ];

  return (
    <StepIconContainer ownerState={ownerState} className={className}>
      {stepLabels[Number(icon) - 1]} 
    </StepIconContainer>
  );
}


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MedicalAbstractBackground/>
      {loading && (
              <Box
                sx={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: 9999,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: 80, 
                    height: 80, 
                    animation: `${spinAnimation} 1.5s linear infinite`,
                  }}
                >
                  {dotPositions.map((pos, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: 8, 
                        height: 8, 
                        borderRadius: "50%",
                        backgroundColor: "#1A237E", 
                        position: "absolute",
                        ...pos,
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}
      

     

        
        <Card sx={{ width: "1000px", maxWidth: "1200px", padding: 3 }}>
          <MDBox pt={4} pb={3} px={3}>
           <CustomStepper
  alternativeLabel
  activeStep={activeStep}
  connector={<CustomConnector />}
>
  {steps.map((label, index) => (
    <Step key={label}>
      <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
    </Step>
  ))}
</CustomStepper>


<form onSubmit={handleSubmit}>
            <MDTypography  sx={{  marginBottom: "20px",   textAlign: "center",fontSize: "15px", fontWeight: "bold", marginBottom: "10px" }}>Create Patient Profile</MDTypography>

              <Grid container spacing={2}>

                {/* Profile Photo Upload */}
<Grid item xs={12} style={{ textAlign: "center" }}>
  {customerDetails.patRegentity?.image && (
    <img
      src={`data:image/*;base64,${customerDetails.patRegentity.image}`}
      alt="Profile Preview"
      style={{
        width: "120px",
        height: "120px",
        borderRadius: "50%",
        objectFit: "cover",
        marginBottom: "10px",
      }}
    />
  )}

  {/* Upload Button */}
  <input
    accept="image/*"
    style={{ display: "none" }}
    id="upload-profile-photo"
    type="file"
    onChange={(e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setCustomerDetails({
            ...customerDetails,
            patRegentity: {
              ...customerDetails.patRegentity,
              imageMeta: file.name,
              image: reader.result.split(",")[1], // base64
            },
          });
        };
        reader.readAsDataURL(file);
      }
    }}
  />
  <br/>
  <label htmlFor="upload-profile-photo">
    <MDButton
      component="span"
      style={{
        backgroundColor: "#1A237E",
        color: "#fff",
        textTransform: "none",
        minWidth: "160px",   // reduced length
        height: "36px",
      }}
    >
      Upload Profile Photo
    </MDButton>
  </label>
</Grid>
          <Grid container spacing={2}>
    {activeStep === 0 && (
              <>
          <Grid item xs={12}>
    <h5>Personal Information</h5>
  </Grid>

        <Grid item xs={6}>
          <MDInput
            type="text"
            label="First Name"
            fullWidth
            value={customerDetails.patRegentity?.firstname}
            onChange={(e) =>
                setCustomerDetails
                ({ ...customerDetails, patRegentity: { ...customerDetails.patRegentity, firstname: e.target.value } })
            }
            
            
          />
          {formErrors.firstname && (
                      <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                        {formErrors.firstname}
                      </Typography>
                    )}
        </Grid>
         <Grid item xs={6}>
          <MDInput
            type="text"
            label="Last Name"
            fullWidth
            value={customerDetails.patRegentity?.lastname}
            onChange={(e) =>
                setCustomerDetails
                ({ ...customerDetails, patRegentity: { ...customerDetails.patRegentity, lastname: e.target.value } })
            }
            
            
          />
        </Grid>
        <Grid item xs={6}>
          <MDInput
            type="email"
            label="Email"
            fullWidth
            value={customerDetails?.username}
            onChange={(e) => setCustomerDetails
                ({ ...customerDetails, username: e.target.value })}
            required
          />
          {formErrors.username && (
                      <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                        {formErrors.username}
                      </Typography>
                    )}
        </Grid>
       <Grid item xs={6}>
         <Grid container spacing={1}>
           <Grid item xs={4}>
             <MDInput
               select
               label="Country Code"
               fullWidth
               value={customerDetails.patRegentity?.phoneCountryCode || "+91"}
               onChange={(e) =>
                 setCustomerDetails({
                   ...customerDetails,
                   patRegentity: {
                     ...customerDetails.patRegentity,
                     phoneCountryCode: e.target.value,
                   },
                 })
               }
               sx={{
                 "& .MuiInputBase-root": {
                   height: "45px",
                 },
               }}
             >
               {countryCodes.map((item) => (
                 <MenuItem key={item.code} value={item.code}>
                   {`${item.name} (${item.code})`}
                 </MenuItem>
               ))}
             </MDInput>
           </Grid>
               {/* Phone Number Input */}
        <Grid item xs={8}>
          <MDInput
            type="text"
            label="Phone Number"
            fullWidth
            value={customerDetails.patRegentity?.phone}
           onChange={(e) => {
      const code = customerDetails.patRegentity?.phoneCountryCode || "+91";
      const maxLength = countryPhoneRules[code] || 10;
      const value = e.target.value.replace(/\D/g, ""); // only digits
      if (value.length <= maxLength) {
        setCustomerDetails({
          ...customerDetails,
          patRegentity: {
            ...customerDetails.patRegentity,
            phone: value,
          },
        });
      }
    }}
       onBlur={() => {
      const phone = customerDetails.patRegentity?.phone || "";
      const code = customerDetails.patRegentity?.phoneCountryCode || "+91";
      const expectedLength = countryPhoneRules[code] || 10;
      const pattern = countryPhonePatterns[code];

      if (phone.length !== expectedLength) {
        setFormErrors((prev) => ({
          ...prev,
          phoneNumber: `Phone number must be exactly ${expectedLength} digits for ${code}`,
        }));
      } else if (!pattern.test(phone)) {
        setFormErrors((prev) => ({
          ...prev,
          phoneNumber: `Invalid phone number format for ${code}`,
        }));
      } else {
        setFormErrors((prev) => ({ ...prev, phone: "" }));
      }
    }}
      />
    </Grid>
  </Grid>

  {/* Error Message */}
 {formErrors.phone ? (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.phone}
  </Typography>
) : (
  <Typography sx={{ fontSize: "12px", color: "gray", mt: 0.5 }}>
    {customerDetails.patRegentity?.phoneCountryCode === "+91"
      ? "Enter a 10-digit Indian number (e.g., 9876543210)"
      : `Enter ${
          countryPhoneRules[customerDetails.patRegentity?.phoneCountryCode || "+91"]
        } digits phone number for ${
          countryCodes.find(
            (c) => c.code === customerDetails.patRegentity?.phoneCountryCode
          )?.name || "selected country"
        }`}
  </Typography>
)}

</Grid>
      <Grid item xs={6}>
         <Grid container spacing={1}>
           <Grid item xs={4}>
             <MDInput
               select
               label="Country Code"
               fullWidth
               value={customerDetails.patRegentity?.emergencyCountryCode || "+91"}
               onChange={(e) =>
                 setCustomerDetails({
                   ...customerDetails,
                   patRegentity: {
                     ...customerDetails.patRegentity,
                     emergencyCountryCode: e.target.value,
                   },
                 })
               }
               sx={{
                 "& .MuiInputBase-root": {
                   height: "45px",
                 },
               }}
             >
               {countryCodes.map((item) => (
                 <MenuItem key={item.code} value={item.code}>
                   {`${item.name} (${item.code})`}
                 </MenuItem>
               ))}
             </MDInput>
           </Grid>
               {/* Phone Number Input */} 
 <Grid item xs={8}>
          <MDInput
            type="text"
            label=" Emergency Number"
            fullWidth
            value={customerDetails.patRegentity?.emergencyPhoneNumber}
            onChange={(e) => {
      const code = customerDetails.patRegentity?.emergencyCountryCode || "+91";
      const maxLength = countryPhoneRules[code] || 10;
      const value = e.target.value.replace(/\D/g, ""); // only digits
      if (value.length <= maxLength) {
        setCustomerDetails({
          ...customerDetails,
          patRegentity: {
            ...customerDetails.patRegentity,
            emergencyPhoneNumber: value,
          },
        });
      }
    }}
       onBlur={() => {
      const emergencyPhoneNumber = customerDetails.patRegentity?.emergencyPhoneNumber || "";
      const code = customerDetails.patRegentity?.emergencyCountryCode || "+91";
      const expectedLength = countryPhoneRules[code] || 10;
      const pattern = countryPhonePatterns[code];

      if (emergencyPhoneNumber.length !== expectedLength) {
        setFormErrors((prev) => ({
          ...prev,
          emergencyPhoneNumber: `Phone number must be exactly ${expectedLength} digits for ${code}`,
        }));
      } else if (!pattern.test(emergencyPhoneNumber)) {
        setFormErrors((prev) => ({
          ...prev,
          emergencyPhoneNumber: `Invalid phone number format for ${code}`,
        }));
      } else {
        setFormErrors((prev) => ({ ...prev, emergencyPhoneNumber: "" }));
      }
    }}
      />
    </Grid>
  </Grid>

  {/* Error Message */}
 {formErrors.emergencyPhoneNumber ? (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.emergencyPhoneNumber}
  </Typography>
) : (
  <Typography sx={{ fontSize: "12px", color: "gray", mt: 0.5 }}>
    {customerDetails.patRegentity?.emergencyCountryCode === "+91"
      ? "Enter a 10-digit Indian number (e.g., 9876543210)"
      : `Enter ${
          countryPhoneRules[customerDetails.patRegentity?.emergencyCountryCode || "+91"]
        } digits phone number for ${
          countryCodes.find(
            (c) => c.code === customerDetails.patRegentity?.emergencyCountryCode
          )?.name || "selected country"
        }`}
  </Typography>
)}

</Grid>
       <Grid item xs={6}>
  <MDInput
    select
    label="Gender"
    fullWidth
    value={customerDetails.patRegentity?.gender || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        patRegentity: { ...customerDetails.patRegentity, gender: e.target.value },
      })
    }
    required
    sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
  >  
    <MenuItem value="Male">Male</MenuItem>
    <MenuItem value="Female">Female</MenuItem>
    <MenuItem value="Others">Others</MenuItem>
  </MDInput>
    {formErrors.gender && (
              <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                {formErrors.gender}
              </Typography>
            )}
</Grid>
      <Grid item xs={6}>
  <MDInput
    select
    label="Marital Status"
    fullWidth
    value={customerDetails.patRegentity?.martialStatus || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        patRegentity: { ...customerDetails.patRegentity, martialStatus: e.target.value },
      })
    }  
    sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    
  >
    <MenuItem value="Single">Single</MenuItem>
    <MenuItem value="Married">Married</MenuItem>
    <MenuItem value="Divorced">Divorced</MenuItem>
    <MenuItem value="Widowed">Widowed</MenuItem>
  </MDInput>
   {formErrors.martialStatus && (
              <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                {formErrors.martialStatus}
              </Typography>
   )}
</Grid>
<Grid item xs={6}>
  <MDInput
    type="date"
    label="Date of Birth"
    fullWidth
    InputLabelProps={{ shrink: true }}
     inputProps={{
    max: today, // ✅ prevents future dates in calendar
  }}
    value={customerDetails.patRegentity?.dob || ""}
    onChange={(e) => {
      let dobValue = e.target.value;

      // Truncate year to 4 digits if user typed or pasted more
      const [year, month, day] = dobValue.split("-");
      if (year && year.length > 4) {
        dobValue = `${year.slice(0, 4)}-${month || ""}-${day || ""}`;
      }

      const age = calculateAge(dobValue);

      setCustomerDetails({
        ...customerDetails,
        patRegentity: {
          ...customerDetails.patRegentity,
          dob: dobValue,
          age: isNaN(age) ? "" : age.toString(),
        },
      });
    }}
  />

  {formErrors.dob && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.dob}
    </Typography>
  )}
</Grid>

         <Grid item xs={6}>
          <MDInput
            type="text"
            label="Age"
            fullWidth
             placeholder="Calculated from Date of Birth"
            value={customerDetails.patRegentity?.age}
             InputProps={{
      readOnly: true, // makes the input non-editable
    }}
            onChange={(e) =>
              
                setCustomerDetails
                ({ ...customerDetails, patRegentity: { ...customerDetails.patRegentity, age: e.target.value } })
            }
             

    // helperText="This field is automatically calculated based on Date of Birth"
          />
        </Grid>
         </>
            )}
                 {/* ===== Address Information Section ===== */}
                 {activeStep === 1 && (
              <>
  <Grid item xs={12}>
    <h5>Address Information</h5>
  </Grid>

  {/* Address */}
   <Grid item xs={12}>
    <MDInput
      type="text"
      label="Address1"
      fullWidth
      value={customerDetails.patRegentity?.address || ""}
      onChange={(e) =>
        setCustomerDetails({
          ...customerDetails,
          patRegentity: { ...customerDetails.patRegentity, address: e.target.value },
        })
      }
      
    />
    {formErrors.address && (
                <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                  {formErrors.address}
                </Typography>
              )}
  </Grid>
  <Grid item xs={12}>
    <MDInput
      type="text"
      label="Address2"
      fullWidth
      value={customerDetails.patRegentity?.address1 || ""}
      onChange={(e) =>
        setCustomerDetails({
          ...customerDetails,
          patRegentity: { ...customerDetails.patRegentity, address1: e.target.value },
        })
      }
    
    />
     {formErrors.address1 && (
                <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                  {formErrors.address1}
                </Typography>
              )}
  </Grid>

  {/* Country */}
  
  <Grid item xs={4}>
  <Autocomplete
    options={countries}
    getOptionLabel={(option) => option.name}
    value={
      countries.find((c) => c.isoCode === customerDetails.patRegentity?.country) ||
      null
    }
    onChange={(e, value) => handleCountryChange(value?.isoCode || "")}
    renderInput={(params) => <TextField {...params} label="Country" fullWidth />}
  />
  {formErrors.country && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.country}
    </Typography>
  )}
</Grid>

{/* State */}
<Grid item xs={4}>
  <Autocomplete
    options={states}
    getOptionLabel={(option) => option.name}
    value={
      states.find((s) => s.isoCode === customerDetails.patRegentity?.state) ||
      null
    }
    onChange={(e, value) => handleStateChange(value?.isoCode || "")}
    renderInput={(params) => <TextField {...params} label="State" fullWidth />}
  />
  {formErrors.state && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.state}
    </Typography>
  )}
</Grid>

{/* District */}
<Grid item xs={4}>
  <Autocomplete
    options={districts}
    getOptionLabel={(option) => option.name}
    value={
      districts.find((d) => d.name === customerDetails.patRegentity?.district) ||
      null
    }
    onChange={(e, value) =>
      setCustomerDetails({
        ...customerDetails,
        patRegentity: {
          ...customerDetails.patRegentity,
          district: value?.name || "",
        },
      })
    }
    renderInput={(params) => <TextField {...params} label="District" fullWidth />}
  />
  {formErrors.district && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.district}
    </Typography>
  )}
</Grid>

  {/* Pincode */}
  <Grid item xs={6}>
    <MDInput
      type="number"
      label="Pincode"
      fullWidth
      inputProps={{ maxLength: 6 }}
      value={customerDetails.patRegentity?.pin || ""}
      onChange={(e) =>
        setCustomerDetails({
          ...customerDetails,
          patRegentity: { ...customerDetails.patRegentity, pin: e.target.value },
        })
      }
      
    />
     {formErrors.pin && (
                <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                  {formErrors.pin}
                </Typography>
              )}
  </Grid>
</>
)}
  {/* ===== Professional Details Section ===== */}
   {activeStep === 2 && (
              <>
<Grid item xs={12}>
  <h5>Mapping Details</h5>
</Grid>





<Grid item xs={6}>
  <MDInput
    select
    label="Doctor Type"
    fullWidth
    value={customerDetails.patRegentity?.doctorType || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        patRegentity: { ...customerDetails.patRegentity, doctorType: e.target.value },
      })
    }
     sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    
  >
     {loading ? (
            <MenuItem disabled>Loading...</MenuItem>
          ) : (
            doctorList.map((doc) => (
              <MenuItem key={doc.doctor_type} value={doc.doctor_type}>
                {doc.doctor_type}
              </MenuItem>
            ))
          )}
        </MDInput>
         {formErrors.doctorType && (
                    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                      {formErrors.doctorType}
                    </Typography>
                  )}
</Grid>
 <Grid item xs={6}>
        <MDInput
          select
          label="Doctor Name"
          fullWidth
          value={customerDetails.patRegentity?.primarydoctorid || ""}
          onChange={(e) =>
            setCustomerDetails({
              ...customerDetails,
              patRegentity: {
                ...customerDetails.patRegentity,
                primarydoctorid: e.target.value,
              },
            })
          }
          sx={{ "& .MuiInputBase-root": { height: "45px" } }}
          required
          disabled={!customerDetails.patRegentity?.doctorType}
        >
          {loading ? (
            <MenuItem disabled>Loading...</MenuItem>
          ) : (
            doctorNameList.map((doc) => (
              <MenuItem key={doc.id} value={doc.id}>
                {doc.firstname} {doc.lastname}
              </MenuItem>
            ))
          )}
        </MDInput>
         {formErrors.primarydoctorid && (
                    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                      {formErrors.primarydoctorid}
                    </Typography>
                  )}
      </Grid>
 </>
            )}
</Grid>
 
 {activeStep === 3 && (
  <>
    {["Aadhar Card", "Pan Card", "Driving License"].map((docName, index) => {
      const existingDoc = customerDetails.document.find((d) => d.documentname === docName);
      const doc = existingDoc || {
        documentname: docName,
        documenttype: "",
        dateofupload: getCurrentDate(),
        image: "",
        verified: docName === "Aadhar Card" ? false : true,
      };

      return (
        <Grid container spacing={2} key={index} mt={1}>
          {/* Document Name (read-only since fixed) */}
          <Grid item xs={6}>
            <TextField
              label="Document Name"
              fullWidth
              value={doc.documentname}
              InputProps={{ readOnly: true }}
              sx={{
                "& .MuiInputBase-root": { height: "45px" },
              }}
            />
          </Grid>

          {/* Document Type */}
          {/* <Grid item xs={6}>
            <MDInput
              label="Document Type"
              fullWidth
              value={doc.documenttype}
              onChange={(e) => {
                const updatedDocs = [...customerDetails.document];
                const existingIdx = updatedDocs.findIndex((d) => d.documentname === docName);
                if (existingIdx !== -1) {
                  updatedDocs[existingIdx].documenttype = e.target.value;
                } else {
                  updatedDocs.push({ ...doc, documenttype: e.target.value });
                }
                setCustomerDetails({ ...customerDetails, document: updatedDocs });
              }}
            />
          </Grid> */}

          {/* Date of Upload */}
          {/* <Grid item xs={6}>
            <MDInput
              type="date"
              label="Date of Upload"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={doc.dateofupload}
              onChange={(e) => {
                const updatedDocs = [...customerDetails.document];
                const existingIdx = updatedDocs.findIndex((d) => d.documentname === docName);
                if (existingIdx !== -1) {
                  updatedDocs[existingIdx].dateofupload = e.target.value;
                } else {
                  updatedDocs.push({ ...doc, dateofupload: e.target.value });
                }
                setCustomerDetails({ ...customerDetails, document: updatedDocs });
              }}
            />
          </Grid> */}

          {/* File Upload */}
        <Grid item xs={6}>
  {/* File Upload */}
  <input
    accept="image/*"
    type="file"
    id={`file-upload-${index}`}
    style={{ display: "none" }}
    onChange={(e) => {
      const file = e.target.files[0];
      if (!file) return;

      const duplicate = customerDetails.document.some(
        (d, idx) => d.documentname === docName && idx !== index
      );

      const updatedDocs = [...customerDetails.document];

      if (duplicate) {
        updatedDocs[index] = {
          ...updatedDocs[index],
          errors: {
            ...updatedDocs[index]?.errors,
            duplicate: "This document is already uploaded",
          },
        };
        setCustomerDetails({ ...customerDetails, document: updatedDocs });
        return;
      }

      updatedDocs[index] = {
        ...updatedDocs[index],
        documentname: docName,
        errors: { ...updatedDocs[index]?.errors, duplicate: "" },
      };

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result.split(",")[1];
        const newDoc = {
          ...updatedDocs[index],
          imageMeta: file.name,
          image: base64Data,
        };
        updatedDocs[index] = newDoc;
        setCustomerDetails({ ...customerDetails, document: updatedDocs });
      };
      reader.readAsDataURL(file);
    }}
  />

  {/* Row layout for Choose File + File Link + Delete */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    {/* Choose File Button */}
    <label htmlFor={`file-upload-${index}`}>
      <MDButton
        component="span"
        variant="outlined"
        sx={{
          textTransform: "none",
          color: "#1A237E",
          borderColor: "#1A237E",
          height: "36px",
          minWidth: "110px",
          fontSize: "13px",
          "&:hover": { backgroundColor: "#e3f2fd" },
        }}
      >
        Choose File
      </MDButton>
    </label>

    {/* File Link and Delete Icon (inline) */}
    {doc.imageMeta && (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography
          sx={{
            color: "#1A237E",
            cursor: "pointer",
            textDecoration: "underline",
            fontSize: "13px",
            flexShrink: 0,
          }}
          onClick={() => {
            const ext = doc.imageMeta.split(".").pop().toLowerCase();
            const byteCharacters = atob(doc.image);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            let mimeType = "application/octet-stream";
            if (["jpg", "jpeg"].includes(ext)) mimeType = "image/jpeg";
            else if (ext === "png") mimeType = "image/png";
            else if (ext === "gif") mimeType = "image/gif";
            else if (ext === "pdf") mimeType = "application/pdf";
            else if (ext === "doc") mimeType = "application/msword";
            else if (ext === "docx")
              mimeType =
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

            const blob = new Blob([byteArray], { type: mimeType });
            const url = URL.createObjectURL(blob);

            if (["jpg", "jpeg", "png", "gif", "pdf"].includes(ext)) {
              window.open(url, "_blank");
            } else {
              const a = document.createElement("a");
              a.href = url;
              a.download = doc.imageMeta;
              a.click();
            }
          }}
        >
          {doc.imageMeta}
        </Typography>

        <IconButton
          size="small"
          color="error"
          onClick={() => {
            const updatedDocs = [...customerDetails.document];
            updatedDocs[index] = {
              ...updatedDocs[index],
              imageMeta: "",
              image: "",
            };
            setCustomerDetails({ ...customerDetails, document: updatedDocs });
          }}
          sx={{ p: 0 }}
        >
          <DeleteIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>
    )}
  </Box>

  {/* Duplicate Error */}
  {doc.errors?.duplicate && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {doc.errors.duplicate}
    </Typography>
  )}
</Grid>




          {/* Aadhaar Verification Button */}
          {doc.documentname === "Aadhar Card" && !doc.verified && (
            <Grid item xs={12}>
              <MDButton
                variant="outlined"
                onClick={() => {
                  window.open("https://myaadhaar.uidai.gov.in/", "_blank");
                  const updatedDocs = [...customerDetails.document];
                  const idx = updatedDocs.findIndex((d) => d.documentname === docName);
                  if (idx !== -1) updatedDocs[idx].verified = true;
                  setCustomerDetails({ ...customerDetails, document: updatedDocs });
                }}
                sx={{
                  background: "#1A237E",
                  color: "#fff",
                  "&:hover": { background: "#1A237E1" },
                  mt: 1,
                }}
              >
                Verify Aadhaar
              </MDButton>
            </Grid>
          )}
        </Grid>
      );
    })}
  </>
)}
        </Grid>

              <MDBox mt={3} display="flex" justifyContent="space-between">
  <MDButton
    variant="outlined"
    disabled={activeStep === 0}
    onClick={handleBack}
          style={{ backgroundColor: "#1A237E", color: "#fff", textTransform: "none" }}

  >
    Back
  </MDButton>

  {activeStep === steps.length - 1 ? (
    <MDButton
      variant="contained"
      onClick={handleSubmit}
      style={{ backgroundColor: "#1A237E", color: "#fff", textTransform: "none" }}
    >
      Submit
    </MDButton>
  ) : (
    <MDButton
      variant="contained"
      onClick={handleNext}
      style={{ backgroundColor: "#1A237E", color: "#fff", textTransform: "none" }}
    >
      Next
    </MDButton>
  )}
</MDBox>

            </form>
          </MDBox>
        </Card>
      
     
    </DashboardLayout>
  );
}

export default CreatePatientProfile;

